import { Typography } from "@mui/material";
import Hero from "components/wpPage/Hero";
import Section from "components/wpPage/Section";
import * as React from "react";

// 线上页面就是标题 + 一段 Lorem ipsum 占位文字，照原样迁移
export default function PrintOnDemandForWix(): React.ReactElement {
  return (
    <>
      <Hero title="print on demand for wix" sx={{ py: { xs: 6, md: 10 } }} />

      <Section>
        <Typography variant="body1" color="textSecondary" sx={{ maxWidth: { md: "50%" } }}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis,
          pulvinar dapibus leo.
        </Typography>
      </Section>
    </>
  );
}
